import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['date', 'time']

  date_on_paste(e) {
    try {
      let text = (e.clipboardData || window.clipboardData).getData('text')
      let date = new Date(text.trim().replace(/\s+/g, " "))

      let date_str = date.format("yyyy-mm-dd")
      let time_str = date.format("HH:MM")
      let date_el = $(e.currentTarget)

      if (date.toJSON().substring(10,24) != "T00:00:00.000Z") {
        date_el.val(date_str)
        $(`#${date_el.attr('id').replace('date','time')}`).val(time_str)
        e.preventDefault()
      }
    } catch (error) {

    }
  }

  clear_datetime(e) {
    e.preventDefault()
    console.log('hello')
    this.dateTarget.value = ""
    this.timeTarget.value = ""
  }

}
